export default {
  "format": "DD/MM/YYYY",
  "separator": " - ",
  "applyLabel": "Aplicar",
  "cancelLabel": "Cancelar",
  "fromLabel": "De",
  "toLabel": "Até",
  "customRangeLabel": "Personalizado",
  "weekLabel": "W",
  "daysOfWeek": [
      "Dom",
      "Seg",
      "Ter",
      "Qua",
      "Qui",
      "Sex",
      "Sab"
  ],
  "monthNames": [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
  ],
  "firstDay": 0
}